import React from "react";
import { NavLink } from "react-router-dom";
import {
    AiOutlineDashboard,
    AiOutlineUpload,
    AiOutlineLock,
    AiOutlineFolderOpen,
    AiOutlineFileText,
    AiOutlineFileDone,
    AiOutlineFileAdd
} from "react-icons/ai";

const sidebarWidth = (open) => (open ? 200 : 60);

const styles = {
    sidebar: (open, isMobile) => ({
        width: isMobile ? 200 : sidebarWidth(open),
        minWidth: isMobile ? 200 : sidebarWidth(open),
        //background: "linear-gradient(90deg, #6B46C1, #D53F8C 70%)",
        background: "#5f5f64ff", // Indigo
        color: "#e0e7ff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        transition: isMobile ? "transform 0.3s ease" : "width 0.3s ease",
        zIndex: isMobile ? 100 : 100,
        height: "100vh",
        position: "fixed",
        left: 0,
        top: 0,
        overflowY: "auto",
        overflowX: "hidden",
        boxShadow: "2px 0 15px rgb(79 70 229 / 0.4)",
        transform: isMobile ? (open ? "translateX(0)" : "translateX(-100%)") : "none",
    }),
    navSection: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "stretch",
        marginTop: 0,
        gap: 8,
        paddingTop: "20px",
        paddingBottom: "20px",
    },
    navLink: (active, open) => ({
        color: active ? "#f3f4f6" : "#ddd6fe",
        background: active ? "#6366f1" : "transparent",
        padding: open ? "13px 28px" : "12px 0",
        display: "flex",
        alignItems: "center",
        gap: open ? 14 : 0,
        fontWeight: 600,
        borderLeft: active ? "5px solid #a5b4fc" : "5px solid transparent",
        textDecoration: "none",
        fontSize: 16,
        borderRadius: "12px",
        margin: "3px 10px",
        transition: "all 0.2s ease",
        justifyContent: open ? "flex-start" : "center",
        userSelect: "none",
    }),
};

export default function UserSidebar({ sidebarOpen, setSidebarOpen, isMobile = false }) {
    return (
        <>
            <style>{`
                .user-sidebar::-webkit-scrollbar {
                    width: 6px;
                }
                .user-sidebar::-webkit-scrollbar-track {
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 10px;
                }
                .user-sidebar::-webkit-scrollbar-thumb {
                    background: rgba(255, 255, 255, 0.3);
                    border-radius: 10px;
                }
                .user-sidebar::-webkit-scrollbar-thumb:hover {
                    background: rgba(255, 255, 255, 0.5);
                }
            `}</style>
            <nav 
                style={styles.sidebar(sidebarOpen, isMobile)} 
                className={isMobile && sidebarOpen ? "user-sidebar open" : "user-sidebar"}
                aria-label="Sidebar"
            >
                {/* <div style={{ height: 64 }} /> */}
                <div style={styles.navSection}>
                <NavLink
                    to="/user/dashboard"
                    end
                    style={({ isActive }) => styles.navLink(isActive, sidebarOpen)}
                >
                    <AiOutlineDashboard size={40} />
                    {sidebarOpen && "Dashboard"}
                </NavLink>
                <NavLink
                    to="/user/downloadform"
                    style={({ isActive }) => styles.navLink(isActive, sidebarOpen)}
                >
                    <AiOutlineFolderOpen size={40} />
                    {sidebarOpen && "Download Form"}
                </NavLink>
                <NavLink
                    to="/user/uploaddocuments"
                    style={({ isActive }) => styles.navLink(isActive, sidebarOpen)}
                >
                    <AiOutlineUpload size={40} />
                    {sidebarOpen && "Upload Documents"}
                </NavLink>
                <NavLink
                    to="/user/downloaddraftcopy"
                    style={({ isActive }) => styles.navLink(isActive, sidebarOpen)}
                >
                    <AiOutlineFileText size={40} />
                    {sidebarOpen && "Download Tax Return Draft Copy"}
                </NavLink>
                <NavLink
                    to="/user/downloadfinalcopy"
                    style={({ isActive }) => styles.navLink(isActive, sidebarOpen)}
                >
                    <AiOutlineFileDone size={40} />
                    {sidebarOpen && "Download Tax Return Final Copy"}
                </NavLink>
                <NavLink
                    to="/user/amendment"
                    style={({ isActive }) => styles.navLink(isActive, sidebarOpen)}
                >
                    <AiOutlineFileAdd size={40} />
                    {sidebarOpen && "Amendment Uploads"}
                </NavLink>
                <NavLink
                    to="/user/changepassword"
                    style={({ isActive }) => styles.navLink(isActive, sidebarOpen)}
                >
                    <AiOutlineLock size={40} />
                    {sidebarOpen && "Change Password"}
                </NavLink>
            </div>
        </nav>
        </>
    );
}
